import useOutsideEvent from './useOutsideEvent.js';

export default function useClickOutside(callback) {
  const EVENTS = ['click', 'touchstart'];
  // returns ref for the element that we want to detect clicks outside of
  return useOutsideEvent(callback, EVENTS);
}

// ? How to use
// const ref = useClickOutside(() => {
//    Your custom logic here
// });
//
// return <div ref={ref}>...</div>;
